import Image from "next/image";
import classNames from "classnames";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./ArticleWithPictureWithSubDescription.module.scss";

export type ArticleWithPictureWithSubDescriptionProps = {
  title: string;
  description: string;
  subDescription: string;
  image: StrapiEntity<StrapiImage>;
  imagePosition: string;
};

export const ArticleWithPictureWithSubDescription = ({
  title,
  description,
  subDescription,
  image,
  imagePosition,
}: ArticleWithPictureWithSubDescriptionProps) => {
  const strapiImage = formatStrapiEntity(image);

  return (
    <div
      className={classNames(styles.container, {
        [styles.containerRight]: imagePosition === "right",
      })}
    >
      <div className={styles.imageContainer}>
        <div className={styles.image}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            objectFit="cover"
            objectPosition="center"
            alt={strapiImage.alternativeText ?? ""}
            layout="fill"
          />
        </div>
      </div>
      <div className={styles.articleContainer}>
        <h2 className={styles.title}>{title}</h2>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={injectPurifiedHTML(
            removeEmptyRel(description)
          )}
        />
        <div
          className={styles.subDescription}
          dangerouslySetInnerHTML={injectPurifiedHTML(
            removeEmptyRel(subDescription)
          )}
        />
      </div>
    </div>
  );
};
